import { render, staticRenderFns } from "./SkinListIframe.vue?vue&type=template&id=61824549&"
import script from "./SkinListIframe.vue?vue&type=script&lang=ts&"
export * from "./SkinListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports